import * as fromDistrictSearchResults from '../actions/district-searchresults.action';
import * as fromModels from '../../models';
import { HttpHeaders } from '@angular/common/http';

export interface SearchResultsState {
    searchResults: fromModels.DistrictSearchResultsItem[];
    searchCriteria: fromModels.DistrictSearchCriteria;
    pagingSorting: fromModels.DistrictPagingSorting;
    errors: any;	//	TODO: formalize error handling
    loading: boolean;
    loaded: boolean;
}

export const initialState: SearchResultsState = {
    loading: false,
    loaded: false,
    searchResults: null,
    errors: null,
    searchCriteria: {
        id: null,
        longName: null,
        county: null,
        state: null,
        zip: null,
        radius: null,
        code: null,
        isSupervisory: null,
        isActive: null,
        PageNumber: null,
        PageSize: null,
        SortBy: null,
        SortDir: null
    },
    pagingSorting: {
        totalCount: null,
        pageSize: null,
        currentPage: null,
        totalPages: null,
        sortBy: null,
        sortDir: null
    }
};

export function reducer(state = initialState, action: fromDistrictSearchResults.DistrictSearchResultsActions): SearchResultsState {
    switch (action.type) {
        case fromDistrictSearchResults.DistrictSearchResultsActionTypes.ProcessQueryString: {
            console.log('ProcessQueryString');
            console.log(action.payload);

            return {
                ...state,
                loaded: false,
                loading: false,
                errors: null
            };
        }

        case fromDistrictSearchResults.DistrictSearchResultsActionTypes.LoadDistrictSearchResults: {
            console.log('LoadDistrictSearchResults');
            console.log(action.payload);
			return {
                ...state,
                loaded: false,
                loading: true,
                errors: null,
                // Anytime we request search results, let's update the state to include that
                // most recent criteria that was just passed.
                searchCriteria: action.payload
			};
		}

        case fromDistrictSearchResults.DistrictSearchResultsActionTypes.LoadDistrictSearchResultsSuccess: {
            const searchResults = action.payload;
            const headers = action.httpHeaders;

			return {
                ...updateDistrictSearchResultsState(state, searchResults, headers),
				loaded: true,
                loading: false
			};
		}

        case fromDistrictSearchResults.DistrictSearchResultsActionTypes.LoadDistrictSearchResultsFailure: {
			console.log('reducer:', action);

			return {
				...state,
				loaded: false,
				loading: false,
                errors: action.payload
			};
        }
	}

	return state;
}

function updateDistrictSearchResultsState(state: SearchResultsState, searchResults: fromModels.DistrictSearchResultsItem[], headers: HttpHeaders) {
    let pagingSorting: fromModels.DistrictPagingSorting;

    // Grab special header we use for paging
    const pagingHeader: string = headers.get('X-Pagination');
    const pagingObject: object = JSON.parse(pagingHeader);

    // Populate paging information from http headers
    pagingSorting = {
        totalCount: pagingObject['totalCount'],
        pageSize: pagingObject['pageSize'],
        currentPage: pagingObject['currentPage'],
        totalPages: pagingObject['totalPages'],
        sortBy: pagingObject['sortBy'],
        sortDir: pagingObject['sortDir']
    };

	return {
		...state,
        searchResults,
        pagingSorting
	};
}

export const getDistrictSearchResults = (state: SearchResultsState) => state.searchResults;
export const getDetailsStateLoading = (state: SearchResultsState) => state.loading;
export const getDetailsStateLoaded = (state: SearchResultsState) => state.loaded;
export const getDetailsStateErrors = (state: SearchResultsState) => state.errors;
